import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { CalloutBanner } from "@utils/globalTypes"
import FullyRoundedDarkButton from "../Buttons/FullyRoundedDarkButton"
import * as s from "./CalloutBanner.module.scss"

type Props = {
  banner: any
}

const CallOutBanner = ({ banner = null }: Props) => {
  const { sanityCalloutBanner } =
    !banner &&
    useStaticQuery<{
      sanityCalloutBanner: CalloutBanner
    }>(query)

  return (
    <div className={s.container}>
      <div className={s.content}>
        <p>{banner ? banner.title : sanityCalloutBanner.title}</p>
        <FullyRoundedDarkButton
          onClick={() =>
            window.open(
              banner ? banner.button.link : sanityCalloutBanner.button.link,
              "_blank"
            )
          }
        >
          {banner ? banner.button.label : sanityCalloutBanner.button.label}
        </FullyRoundedDarkButton>
      </div>
    </div>
  )
}

export default CallOutBanner

const query = graphql`
  {
    sanityCalloutBanner {
      title
      button {
        label
        link
      }
    }
  }
`
